<template>
  <div>
    <div class="filter-wrapper">
      <filterlist
        ref="filterlist"
        @getBusinessCode="getBusinessCode"
        @getRegionId="getRegionId"
        @getTicketline="getTicketline"
        @getMetro="getMetro"
        :params='paramsObj'
        :initBusiness="queryParam.business"
        :initDistrict="queryParam.districtCode"
      ></filterlist>
      <officeFilter 
        @changeVal="changeVal" 
        typeTxt="写字楼租赁" 
        :params='paramsObj'
      ></officeFilter>
    </div>
    <el-row class="wid1200 padt20">
      <el-col :span="19" class="lineb">
        <el-row>
          <el-col :span="14">
            <div
              v-for="(item,index) in sort"
              :key="index"
              :class="[
                'Sorting pointer',
                Sorting_active==index ? 'Sorting_active1' : '',
                showArrow(index) ? 'with-arrow' : ''
              ]"
              @click="setSorting(index)"
            >
              {{item}}
              <span v-if="showArrow(index)" class="sort-arrow">
                <span v-if="Sorting_active==index && order=='asc'" class="arrow">↑</span>
                <span v-if="Sorting_active==index && order=='desc'" class="arrow">↓</span>
              </span>
            </div>
          </el-col>
          <el-col :span="10" class="textright">
            共
            <span class="colred">{{total}}</span>套房源满足你的需求
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <!-- 租赁 -->
    <el-row class="wid1200" >
      <el-col :span="19" v-if="officeBuildList.length>0">
        <el-row
          class="padtb20 borderb pointer"
          v-for="(item,index) in officeBuildList"
          :key="index"
          @click.native="toNext(item.id,'2')"
        >
          <el-col :span="6">
            <div class="listmsg">
              <!-- 图片优先 -->
              <template v-if="item.imageUrl">
                <div class="video-container">
                  <el-image :src="item.imageUrl" alt />
                  <div v-if="item.videoUrl" class="video-play-icon">
                    <i class="el-icon-video-play"></i>
                  </div>
                </div>
              </template>
              <!-- 默认图片最后 -->
              <template v-else>
                <el-image src="http://img.sccshf.com/defaultimage1.png" />
              </template>
            </div>
          </el-col>
          <el-col :span="12" :offset="1" class="padl5">
            <!-- <div class="font20 col333 font600 line50 titleHouer">{{item.title }}</div> -->
            <div class="font20 col333 font600 line50 titleHouer">{{commonfun.returnRegion(item.districtCode)}} | {{commonfun.returnBussileList(item.business)}} |{{item.dictName}}|{{item.area}}m²</div>
            <div
              class="font16 col666 line30"
            >{{item.area}}m² / {{commonfun.getDictLabel('dictRenovation',item.renovation)}} / {{commonfun.returnRegion(item.districtCode)}} - {{commonfun.returnBussileList(item.business)}}-{{item.address}}</div>
            <div class="font16 col666 line30">{{item.dictName}} / {{item.olevel }}写字楼</div>
            <div class="font16 col666 line30" v-if="item.houseLabel !=null">
              <div
                :class="'disinline bg'+inq"
                v-for="(it,inq) in item.houseLabel"
                :key="inq"
              >{{commonfun.getDictLabel('houseLabel',it)}}</div>
            </div>
          </el-col>
          <el-col :span="5" class="textright">
            <!-- <div class="colfff line50">0</div> -->
            <div class="colred mart50">
              <span class="font24 font600">{{item.prices}}</span>
              <span class="font16">元/月</span>
            </div>
            <div class="font16 col999 line30">单价：{{item.price}}元/m²/月</div>
            <div class="font16 line24">
              <div class="disinline imghear"></div>
              <template>
                <el-popover placement="top-start" title width="100" trigger="hover" content>
                  <!-- <span class="font16 col999 line30">{{item.mobile}}</span> -->
                  <el-image style="width: 100px; height: 100px" :src="item.wxPhoto"></el-image>
                  <span class="wx" slot="reference">微信咨询</span>
                </el-popover>
              </template>

              <template>
                <el-popover placement="top-start" title width="200" trigger="hover" content>
                  <span class="font16 colred line30 el-icon-phone">{{item.userName}}/{{item.mobile}}</span>

                  <span class="tel" slot="reference">电话咨询</span>
                </el-popover>
              </template>
            </div>
          </el-col>
        </el-row>
        <el-row></el-row>
      </el-col>
      <el-col :span="19" v-else class="line50 textcenter">
        <div v-if="!dataload">
          数据加载中
        </div>
        <div v-else>暂无数据 </div>
        </el-col>
      <!-- <el-col :span="4" :offset="1">
         <template>
          <div class="font20">城市好房手机端</div>
          <el-tabs v-model="activeName">
            <el-tab-pane class="font12 padtl5" label="公众号" name="first" id="padtl5">
              <el-image
                style="width: 150px; height: 150px"
                src="/static/img/rcord.png"
              ></el-image>
              <div class="font12">关注城市好房公众号</div>
            </el-tab-pane>
            <el-tab-pane class="font12 padtl5" label="app" name="second" id="padtl5">
              <el-image
                style="width: 150px; height: 150px"
                src="/static/img/xiaochengxu.jpg" 
                 
              ></el-image>
            </el-tab-pane>
            <el-tab-pane class="font12 padtl5" label="微信小程序" name="third" id="padtl5">
              <el-image
                style="width: 150px; height: 150px"
                 src="/static/img/xiaochengxu.jpg" 
              ></el-image>
            </el-tab-pane>
          </el-tabs>
        </template>
      </el-col> -->
     
    </el-row>
   
    <!-- 分页 -->
    <div class="textcenter padt20">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParam.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryParam.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import filterlist from "../../components/filter";
import officeFilter from "../../components/officeFilter";
// import mixinViewModule from '@/util/view-module'
export default {
  data() {
    return {
      checktype: 2,
      type: "",
      sort: ["默认排序", "单价", "面积"],
      Sorting_active: 0,
      order: '',
      total: 0,
      officeBuildList: [],
      queryParam: {
        page: 1, //	当前页码
        limit: 30, //每页显示记录数
        orderField: "", //排序字段
        order: "", //排序方式，可选值(asc、desc)
        tenant_code: this.$store.state.tenantCode, //城市编码
        districtCode: null, //行政区
        business: null, //所属商圈
        metroId: null, //地铁线路
        stationId: null, //地铁站点
        type: null, //写字楼类型
        renovation: null, //装修类型 @dictRenovation
        prices: null, //最低单价
        pricee: null, //最高单价
        pricess: null, //最低总价
        pricese: null, //最低总价
        areas: null, //最低面积
        areae: null, //最高面积
        search: "", //搜索字段,
        dictId:null
      },
       dataload:false,
      activeName: "first",
       paramsObj:''
    };
  },
  props: ["active", "searchVal", "searchId", "searchType", "value"],
  model: {
    prop: 'value',
    event: 'input'
  },
  components: {
    filterlist,
    officeFilter
  },
  mounted() {
    this.$emit('getMenuId', 1);
    
    // 获取路由参数
    const query = this.$route.query;
    const params = this.$route.params;
    console.log("query", JSON.stringify(query));
    console.log("params", JSON.stringify(params));
    
    // 处理从首页跳转过来的参数 - query方式
    if (query.business) {
      this.queryParam.business = query.business;
    }
    if (query.districtCode) {
      this.queryParam.districtCode = query.districtCode;
    }
    // 处理搜索参数
    if (params.search) {
      this.queryParam.search = params.search;
      // 将查询的搜索值传递回父组件 - 使用两种方式
      this.$emit('setSearch', params.search);
    }
    
    // 处理从首页跳转过来的参数 - params方式
    if (params.qy) {
      this.queryParam.districtCode = params.qy;
    }
    
    // 处理装修参数
    if (params.zx) {
      this.queryParam.renovation = params.zx;
    }
    
    // 处理面积参数
    if (params.area) {
      const areaRange = params.area.split('-');
      if (areaRange.length === 2) {
        this.queryParam.areas = areaRange[0];
        this.queryParam.areae = areaRange[1];
      }
    }
    
    // 处理params方式的搜索参数
    if (params.search) {
      this.queryParam.search = params.search;
      // 使用两种方式同步到父组件
      this.$emit('setSearch', params.search);
    }
    
    // 将参数转为JSON字符串，传递给子组件
    this.paramsObj = JSON.stringify({
      business: query.business || null,
      districtCode: query.districtCode || params.qy || null,
      renovation: params.zx || null,
      area: params.area || null,
      search: params.search || params.search || null
    });
    
    // 获取列表数据
    this.getleaseList();
  },
  watch: { 
    searchVal(val){
      console.log("searchId",this.searchId,"searchType",this.searchType);
      if(this.searchId){
        this.queryParam.search="";
        this.queryParam.dictId="";
        this.queryParam.business="";
        this.queryParam.metroId="";
        if(this.searchType==1){
           console.log("13f",this.searchId);
           this.queryParam.dictId=this.searchId
        }else if(this.searchType==2){
          this.queryParam.business=this.searchId
        }else if(this.searchType==3){
          this.queryParam.metroId=this.searchId
        }
      }else{
        this.queryParam.search=val
      }    
      this.getleaseList();
    },
  },
  computed: {},
  methods: {
    // 大区域
    getBusinessCode(val) {
      this.queryParam.districtCode = val;
        this.getleaseList();
     
    },
    // 子区域
    getRegionId(val) {
      this.queryParam.business = val;
        this.getleaseList();
     
    },
    toNext(id) {
     
        let routeUrl = this.$router.resolve({
          path: "/officeLeaseDetail",
          query: {
            houseid: id
          }
        });
        window.open(routeUrl.href, "_blank");
     
    },
    // 地铁线
    getTicketline(val) {
      console.log("ticket", val);
      this.queryParam.metroId = val;
     
        this.getleaseList();
     
    },
    // 地铁站点
    getMetro(val) {
      console.log("Metro", val);
      this.queryParam.stationId = val;
      
        this.getleaseList();
     
    },
    handleSizeChange(val) {
      this.queryParam.limit = val;
      this.getleaseList();
    },
    handleCurrentChange(val) {
      this.queryParam.page = val;
      this.getleaseList();
    },
    changeVal(val) {
      console.log("val438", val);
      if (val.label == "type") {
        this.queryParam.type = val.val;
      } else if (val.label == "mmprice") {
        this.queryParam.prices = val.val.split("-")[0]; //最低单价
        this.queryParam.pricee = val.val.split("-")[1]; //最高单价
      } else if (val.label == "mmtotal") {
        this.queryParam.pricess = val.val.split("-")[0]; //最低总价
        this.queryParam.pricese = val.val.split("-")[1]; //最高总价
      } else if (val.label == "zlprice") {
        this.queryParam.prices = val.val.split("-")[0]; //最低单价
        this.queryParam.pricee = val.val.split("-")[1]; //最高单价
      } else if (val.label == "zltotal") {
        this.queryParam.pricess = val.val.split("-")[0]; //最低总价
        this.queryParam.pricese = val.val.split("-")[1]; //最高总价
      } else if (val.label == "area") {
        this.queryParam.areas = val.val.split("-")[0]; //最低面积
        this.queryParam.areae = val.val.split("-")[1]; //最高面积
      } else if (val.label == "decoration") {
        if (val.val == "-") {
          this.queryParam.renovation = "";
        } else {
          this.queryParam.renovation = val.val;
        }
      }
      
        this.getleaseList();
    },
    // 出租
    getleaseList() {
      this.officeBuildList =[]
      this.$get(this.$api.officeBuild.leaseList, this.queryParam)
        .then(res => {
          console.log("出租列表数据", res);
          if (res.code == 0) {
            this.total = res.data.total;
            res.data.list.forEach((item, index) => {
              item.houseLabel = item.houseLabel
                ? item.houseLabel.split(",")
                : item.houseLabel;
            });

            this.officeBuildList = res.data.list;
          }
          this.dataload = true;
        })
        .catch(err => {
          console.log("出租列表数据", err);
          this.dataload = true;
        });
    },
    showArrow(index) {
      // 只有单价和面积且被选中时显示箭头
      return (index === 1 || index === 2) && index === this.Sorting_active;
    },
    setSorting(index) {
      if (index === 0) {
        // 点击默认排序时清除箭头
        this.Sorting_active = 0;
        this.order = '';
        this.queryParam.orderField = "";
        this.queryParam.order = "";
      } else if (this.Sorting_active === index) {
        // 同一个按钮点击，切换排序方向
        this.order = this.order === 'asc' ? 'desc' : 'asc';
        this.queryParam.order = this.order;
      } else {
        // 切换不同按钮，设置为升序
        this.Sorting_active = index;
        this.order = 'asc';
        this.queryParam.orderField = index === 1 ? "price" : "area";
        this.queryParam.order = this.order;
      }
      
      this.getleaseList();
    }
  }
};
</script>

<style  lang="scss">
@import 'office.scss' ;
.listmsg {
  width: 14.375rem;
  height: 10.575rem;
  border-radius: 0.3rem;
  overflow: hidden;
}
.listmsg img {
  width: 100%;
  height: 100%;
}
.active {
  background-color: #da251e;
  color: #fff !important;
}
.Sorting {
  display: inline-block;
  margin: 0px 10px 0px 0px;
  padding: 6px 8px;
  text-align: left;
  position: relative;
  
  &.with-arrow {
    padding-right: 25px;
  }
}
.sort-arrow {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  
  .arrow {
    color: #fff;
    font-size: 12px;
  }
}
.Sorting_active1 {
  color: #fdfcfc;
  border-bottom: 1px solid #DA251D;
  background: #DA251D;;
  border-radius: 5px 5px 0px 0px;
  
  .sort-arrow .arrow {
    color: #fff;
  }
}
.lineb {
  /* padding-bottom:4px;   */
  border-bottom: 1px solid #ff0000;
}
.wx {
  border: 2px solid #da251e;
  background: #da251e;
  color: #fff;
  border-radius: 0.3125rem;
  padding: 3px;
}
.tel {
  border: 2px solid #da251e;
  color: #da251e;
  border-radius: 0.3125rem;
  padding: 3px;
}
.imghear {
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 50%;
  overflow: hidden;
  vertical-align: middle;
}
.imghear img {
  vertical-align: middle;
}

.filter-wrapper {
    width: 75rem;
    margin: 0 auto;
    margin-bottom: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);
}

.video-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.video-play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50px;
  height: 50px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  i {
    color: #fff;
    font-size: 30px;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/office/OfficeBuildingList.vue